<app-scroll-view class="scroll-view">
  <app-tabs
    class="tabs"
    [items]="tabs"
    [(selectedTabIndex)]="tabIndex"
    [appBlockModalDrag]="!(isMobileModeObservable | async)"
  ></app-tabs>

  <ng-container [ngSwitch]="tabIndex">
    <form
      *ngSwitchCase="0"
      class="main-form"
      [formGroup]="formGroup"
      (ngSubmit)="onSubmit($event)"
    >
      <div class="fields-container">
        <div class="field-set">
          <label label>{{ translationService.getCurrentLanguage()?.type || 'Tipo' }}</label>

          <app-select-box
            formControlName="type"
            [items]="layerTypeItems"
            displayExpr="label"
            valueExpr="value"
            [showErrorEnabled]="false"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          ></app-select-box>
        </div>

        <div class="field-set">
          <label label>URL</label>

          <app-input-box
            formControlName="url"
            [showErrorEnabled]="false"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          ></app-input-box>
        </div>
      </div>

      <div class="actions-container">
        <div
          class="btn-item"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        >
          <app-button
            class="btn-action"
            type="submit"
            buttonType="primary"
            styleType="contained"
            [text]="translationService.getCurrentLanguage()?.add || 'Adicionar'"
            width="100%"
            [disabled]="isBtnAddDisabled"
          ></app-button>
        </div>

        <div
          class="btn-item"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        >
          <app-button
            class="btn-action"
            buttonType="normal"
            styleType="contained"
            [text]="translationService.getCurrentLanguage()?.clear || 'Limpar'"
            width="100%"
            (click)="onBtnClearClickInternal($event)"
          ></app-button>
        </div>
      </div>
    </form>

    <ng-container *ngSwitchCase="1">
      <div class="upload-files-container">
        <app-drop-zone
          class="drop-zone"
          [allowedFilesExt]="allowedFilesExt"
          [info]="dropZoneInfo"
          (onFileChange)="onFileChange($event)"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        ></app-drop-zone>
      </div>
    </ng-container>
  </ng-container>
</app-scroll-view>
